import React, { useMemo } from 'react';
import { Box, Checkbox, Label, Radio, Select, Text } from 'theme-ui';

import {
  Appearance,
  AppearanceValue,
  ThemePresets,
  ThemeValue,
} from '../theme';

type Props = {
  appearance: AppearanceValue;
  theme: ThemeValue;
  saveQueryParams: boolean;
  onAppearanceChange: (appearance: Props['appearance']) => void;
  onThemeChange: (theme: Props['theme']) => void;
  onSaveQueryParamsChange: (value: boolean) => void;
};

const Settings: React.FC<Props> = ({
  appearance,
  theme,
  saveQueryParams,
  onAppearanceChange,
  onThemeChange,
  onSaveQueryParamsChange,
}) => {
  const isMultipleColorModes = useMemo(
    /* @ts-ignore */
    () => !!ThemePresets[theme].theme.colors.modes,
    [appearance, theme],
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Text mb={2}>Appearance</Text>
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          {Object.entries(Appearance).map(([key, value]) => (
            <Label
              key={key}
              htmlFor={`appearance-${key}`}
              mr={3}
              mb={2}
              sx={
                !isMultipleColorModes
                  ? {
                      pointerEvents: 'none',
                      opacity: '0.5',
                    }
                  : undefined
              }>
              <Radio
                id={`appearance-${key}`}
                name={value}
                checked={isMultipleColorModes && appearance === value}
                onChange={() => onAppearanceChange(value)}
              />
              {value.slice(0, 1).toUpperCase()}
              {value.slice(1, value.length)}
            </Label>
          ))}
        </Box>

        <Text mt={3} mb={2}>
          Theme
        </Text>
        <Select
          defaultValue={theme}
          onChange={event => onThemeChange(event.target.value as ThemeValue)}>
          {Object.entries(ThemePresets).map(([key, { value }]) => (
            <option key={key} value={value}>
              {value.slice(0, 1).toUpperCase()}
              {value.slice(1, value.length)}
            </option>
          ))}
        </Select>

        <Label mt={4} mb={2}>
          <Checkbox
            id="save-query-params"
            checked={saveQueryParams}
            onChange={() => onSaveQueryParamsChange(!saveQueryParams)}
          />
          Save parameters
        </Label>
      </Box>
    </Box>
  );
};

export default Settings;
